class commonHelper {
	constructor() {
	
	}

	init() {
	}

	mainNav() {
		if (window.innerWidth > 768) {
			$(window).on('scroll', function() {
				if ($(this).scrollTop() > 100) {
					$('#main-nav').addClass('scrolling');
				} else {
					$('#main-nav').removeClass('scrolling');
				}
			})
		}
		$('.navbar-toggler').on('click', function() {
			$('.navbar-collapse').fadeIn();
			$('body').addClass('no-scroll');
			$('.navbar-collapse .navbar-close').focus();
		});
		$('.navbar-close').on('click', function() {
			$('.navbar-collapse').fadeOut();
			$('body').removeClass('no-scroll');
			$('.navbar-toggler').focus();
		})
		
	}

	loadiframe(el) {
		$(el).on('show.bs.modal', function() {
			var $iframe = $(el).find('.iframe');
			$iframe.attr('src', $iframe.data('src'));

			app.common.modalFocus('#' + $(el).attr('id'));
		});
		$(el).on('hidden.bs.modal', function() {
			var $iframe = $(el).find('.iframe');
			$iframe.attr('src', '');
		});
	}

	displayHover(el) {
		$(el).on('click', function() {
			$(el).next().addClass('show');
			var hover = $(el).next().find('.hover-content');
			$(hover).css('opacity', 1);
			console.log(hover);
		});
		
	}

	modalFocus(target) {
		// Get the modal id and select the modal itself
		var targetObject = document.querySelectorAll(target);

		// Get the current active element so we can refocus on it when we exit the modal
		focusedElBeforeOpen = document.activeElement;    

		// Get the modal dialog
		var dialog = targetObject[0];


		// Select all of the focusable elements within the modal (buttons, a, etc.)
		var focusableEls = dialog.querySelectorAll('button, a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]');
		focusableEls = Array.prototype.slice.call(focusableEls);

		// Grab the first focusable element and the last one
		var firstFocusableEl = focusableEls[0],
		lastFocusableEl = focusableEls[focusableEls.length - 1];

		// Once the modal is shown, focus on the first element
		$(dialog).on('shown.bs.modal', function (e) {
			window.setTimeout(function() {
				firstFocusableEl.focus();

				// Keep user focus rotating within modal until it is exited
				if (focusableEls.length > 0) {						
					keyboardHandler = function keyboardHandler(e) {
					  if (e.keyCode === 9) {
						if (e.shiftKey && document.activeElement === firstFocusableEl) {
						  e.preventDefault();
						  lastFocusableEl.focus();
						} else if (!e.shiftKey && document.activeElement === lastFocusableEl) {
						  e.preventDefault();
						  firstFocusableEl.focus();
						}
					  } else {
							firstFocusableEl.focus();
						}
					};
					dialog.addEventListener('keydown', keyboardHandler);
				  }
			}, 300);
		});

		// On modal close, refocus on the element that had focus before
		dialog.addEventListener('hide.bs.modal', function (e) {
			this.focusedElBeforeOpen.focus();
		});
	
	}

	pauseVideo() {
		$('#pauseLoop').on('click', function() {
			$('.hero-video').hide();
			$('#pauseLoop').hide();
			$('#playLoop').show();
		});
	}
	playVideo() {
		$('#playLoop').on('click', function() {
			$('.hero-video').show();
			$('#pauseLoop').show();
			$('#playLoop').hide();
		});
	}
	
}

window.app.add('common', new commonHelper());